module.exports = __webpack_public_path__ + "media/application/images/2018/instagram@2x-ed1931710d44be0a6538023b8dd91aa4.png";